import React, {useCallback, useEffect, useRef, useState} from 'react';

import Shape from "./Shape";
import ShapeStyling from "./ShapeStyling";

import MapWithMeasurement from './../general/ui/MapWithMeasurement';
import Locations from "./../locations/Locations";
import ShapeInfoPanel from "./../general/ui/ShapeInfoPanel";


export default function ShapePanelControl({ locations, shapes, onShapesChanged, onShapeDelete, onShapeActiveChange, onConvertShape, canEdit = false, onBringToBack, onBringToFront }) {

    const emptyLocations = useRef({positive: [], negative: [], counts: {total: 0, positive: 0, negative: 0}});


    const onShapeChange = (shapeId, union, visible = null, attributes = null) => {
        let newShapes = {...shapes};
        newShapes[shapeId].geoJSON.properties.union = union;

        if (visible !== null) {
            newShapes[shapeId].geoJSON.properties.visible = visible;
        }

        if (attributes !== null) {
            Object.keys(attributes).forEach((key) => {
                newShapes[shapeId].geoJSON.properties[key] = attributes[key];
            });
        }

        onShapesChanged(newShapes);
    }


    return shapes ? Object.keys(shapes).map((shapeId, index) => (
        <Shape
            key={shapeId}
            sortOrder={index}
            id={shapeId}
            data={shapes[shapeId]}
            locations={locations.byShape && locations.byShape[shapeId] ? locations.byShape[shapeId] : emptyLocations.current}
            active={shapes[shapeId].active}
            visible={!(shapes[shapeId].geoJSON && shapes[shapeId].geoJSON.properties && shapes[shapeId].geoJSON.properties.visible === false)}
            canEdit={canEdit}

            onActiveChange={onShapeActiveChange}
            onConvertShape={onConvertShape}
            onSelfDelete={onShapeDelete}
            onShapeChange={onShapeChange}
            onBringToBack={onBringToBack}
            onBringToFront={onBringToFront}
        />
    )) : null;
}